import React from 'react';
import { Row as AntdRow } from 'antd/es/grid/index';
import { ConfigContext } from '../config-provider';
// eslint-disable-next-line react/display-name
const Row = React.forwardRef((props, ref) => {
    const { prefixCls, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('row', prefixCls);
    return React.createElement(AntdRow, { ref: ref, prefixCls: classPrefix, ...otherProps });
});
export default Row;
